import clsx from 'clsx';
import { ForwardedRef, forwardRef, HTMLProps } from 'react';

import styles from '../Editor.module.css';

type PanelProps = HTMLProps<HTMLDivElement>;

export const Panel = forwardRef(
  ({ className, children, ...theirProps }: PanelProps, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <div className={clsx(styles.panel, className)} ref={ref} {...theirProps}>
        {children}
      </div>
    );
  },
);

Panel.displayName = 'Panel';
